import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import { useMemo } from "react";
import { MemoryMessage } from "../hooks/useMemoryMessages";

interface MemoryTypesSidebarProps {
  messages: MemoryMessage[];
}

export default function MemoryTypesSidebar({ messages }: MemoryTypesSidebarProps) {
  const types = useMemo(() => {
    const generic = messages.filter((m) => m.comment_source === "generic").length;
    const youtube = messages.filter((m) => m.comment_source === "youtube").length;
    return [
      { label: "Memorial Page", count: generic },
      { label: "Youtube", count: youtube },
    ];
  }, [messages]);

  const total = types.reduce((sum, t) => sum + t.count, 0) || 1;

  return (
    <Paper sx={{ borderRadius: 3, p: 2.5, boxShadow: 0, border: "1px solid #f1f5f9", mt: 2 }}>
      <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b", mb: 2 }}>
        Memory Types
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {types.map((type) => (
          <Box key={type.label}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
              <Typography sx={{ fontSize: "13px", color: "#475569" }}>{type.label}</Typography>
              <Typography sx={{ fontSize: "13px", color: "#475569", fontWeight: 600 }}>{type.count}</Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={(type.count / total) * 100}
              sx={{
                height: 6,
                borderRadius: 4,
                bgcolor: "#d9d9d9",
                "& .MuiLinearProgress-bar": { bgcolor: "#afafaf", borderRadius: 4 },
              }}
            />
          </Box>
        ))}
      </Box>
    </Paper>
  );
}